import { useSyncExternalStore } from "react";

/**
 * 幅 767px 以下か（docs/10 §9.20：PC＝768px〜、スマホ＝〜767px。形だけ変える）。
 * CSS の @media (max-width:767px) と同じ境目。版（data-view）ではなく窓の幅＝スマホで PC版を選んだとき（viewport 1280）は PC の形
 */
export const NARROW_MQ = "(max-width: 767px)";

function subscribe(cb: () => void): () => void {
  const mq = typeof window.matchMedia === "function" ? window.matchMedia(NARROW_MQ) : null;
  mq?.addEventListener("change", cb);
  return () => mq?.removeEventListener("change", cb);
}
const snapshot = (): boolean => (typeof window.matchMedia === "function" ? window.matchMedia(NARROW_MQ).matches : false);

export function useNarrow(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
